import { Injectable } from "@angular/core";
import { ApiBaseService } from "@core/services/api-base.service";
import { BehaviorSubject, delay, distinctUntilChanged, forkJoin } from "rxjs";
import { AppConstants } from "@core/constants";
import { IIntegrationLink, IIntegrationLinkResponse } from "@shared/interfaces/integration-link.interface";
import { IIntegrationTemplate, IIntegrationTemplateResponse } from "@shared/interfaces/integration-template.interface";
import { ApiInfoDto } from "@core/services/manage-organizations/manage-organization-dto";
import { RegionSettingsDto } from "@core/services/region-settings/region-settings-dto";

@Injectable()
export class IntegrationComponentState {
  private readonly _loading = new BehaviorSubject<boolean>(false);
  private readonly _integrationTemplates = new BehaviorSubject<IIntegrationTemplate[]>([]);
  private readonly _integrations = new BehaviorSubject<IIntegrationLink[]>([]);
  private readonly _apiInfo = new BehaviorSubject<ApiInfoDto[]>([]);
  private readonly _regions = new BehaviorSubject<RegionSettingsDto[]>([]);

  public loading$ = this._loading.asObservable().pipe(delay(0), distinctUntilChanged());
  public integrationTemplates$ = this._integrationTemplates.asObservable();
  public integrations$ = this._integrations.asObservable();
  public apiInfo$ = this._apiInfo.asObservable();
  public regions$ = this._regions.asObservable();

  constructor(
    private _apiService: ApiBaseService
  ) { }

  public loadState(): void {
    this._loading.next(true);

    const requests = {
      templates: this._apiService.getJson<IIntegrationTemplateResponse>(AppConstants.API.INTEGRATIONS.TEMPLATES),
      links: this._apiService.getJson<IIntegrationLinkResponse>(AppConstants.API.INTEGRATIONS.LINKS.LIST),
      apiInfo: this._apiService.getJson<any>(AppConstants.API.ORGANIZATIONS.API_INFO),
      regions: this._apiService.getJson<any>(AppConstants.API.REGION_SETTINGS.LIST)
    };
    forkJoin(requests).subscribe({
      next: ({templates, links, apiInfo, regions}) => {
        this._loading.next(false);
        this._apiInfo.next(apiInfo.results as ApiInfoDto[] ?? []);
        this._integrationTemplates.next(templates.results ?? []);
        this._integrations.next(links.results ?? []);
        this._regions.next(regions.results as RegionSettingsDto[] ?? []);
      },
      error: (err) => {
        this._loading.next(false);
        console.error(err);
      },
    })
  }
}